import React from "react";

import { FormControl } from "react-bootstrap";
import isEqual from "lodash/isEqual";

import FsInput from "./FsInput";

export default class FsSelect extends FsInput {
  componentDidMount() {
    this.ensureValidSelectState();
  }

  componentDidUpdate(prevProps) {
    this.ensureValidSelectState(prevProps);
  }

  ensureValidSelectState(prevProps) {
    const { attribute, options, emptyOption, formState } = this.props;
    const value = formState.readFormAttribute(attribute);

    if (!value && !emptyOption) {
      this.updateWithDirectValue(options[0]);
      return;
    }

    if (!prevProps || isEqual(options, prevProps.options)) {
      return;
    }

    if (Array.isArray(options) && !options.includes(value)) {
      this.updateWithDirectValue(emptyOption || options[0]);
    } else if (!Object.keys(options).includes(value)) {
      this.updateWithDirectValue(emptyOption || Object.keys(options)[0]);
    }
  }

  updateWithDirectValue(value) {
    this.update({ target: { value } });
  }

  renderInput() {
    const { formState, attribute, name, placeholder, disabled } = this.props;
    const { options, emptyOption } = this.props;

    if (options === undefined) {
      return null;
    }

    let optionsHtml;
    const hasOptGroups =
      Array.isArray(options) && options[0] && Array.isArray(options[0][1]);
    /*
      [["Alkoholfreie Getränke", [
          { id: 2, name: "Fruchthaltige Getränke" },
          { id: 3, name: "Limonaden/Softdrinks" },
          { id: 4, name: "alkoholfreie Spirituosen" },
          { id: 5, name: "alkoholfreier Wein/Sekt" },
          { id: 6, name: "alkoholfreies Bier" },
          { id: 7, name: "Eistee" }
        ]
      ]]
     */
    if (hasOptGroups) {
      optionsHtml = options.map(([label, children], index) => {
        return (
          <optgroup label={label} key={index}>
            {children.map(child => (
              <option value={child.id} key={child.name}>
                {child.name}
              </option>
            ))}
          </optgroup>
        );
      });
    } else if (Array.isArray(options)) {
      optionsHtml = options.map((option, index) => {
        return (
          <option key={index} value={option}>
            {option}
          </option>
        );
      });
    } else {
      optionsHtml = Object.entries(options).map((valueAndContent, index) => {
        return (
          <option key={index} value={valueAndContent[0]}>
            {valueAndContent[1]}
          </option>
        );
      });
    }

    return (
      <FormControl
        componentClass="select"
        name={name || attribute}
        value={formState.readFormAttribute(attribute)}
        onChange={this.update.bind(this)}
        placeholder={placeholder}
        disabled={disabled}
      >
        {emptyOption && (
          <option key="empty-option" value="">
            {emptyOption}
          </option>
        )}
        {optionsHtml}
      </FormControl>
    );
  }
}
